import { BaseView, Container, delayedCall, dispatcher, killDelayedCall, ingenuity, SpineBase, clone } from "@quest/base-core";
import { ISpineData } from "@quest/pixi-bridge";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotEventDispatchersBehavior";
import { BaseGameModel, BaseGameView, Reel, SlotEventConstants, SymbolBase } from "@quest/slot-core";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotConstantsBehavior";

export class CascadingReelPanelController {
  private readonly view: any;
  private readonly cascadeView: BaseView;
  private burstSpineArray: SpineBase[] = [];
  private cascadeSymArray: SymbolBase[] = [];
  protected model: BaseGameModel;
  protected cascadingReelsParentContainer: Container;

  constructor(view: BaseGameView, cascadeView: BaseView, model: any) {
    this.view = view;
    this.cascadeView = cascadeView;
    this.model = model;
    this.cascadingReelsParentContainer = this.cascadeView.getContainerByID("cascadingReelsParentContainer")
    this.subscriveEvents();
  }

  /**
   * This method subscribe the  events of this class
   */
  private subscriveEvents(): void {
    dispatcher.on(eventDispatchers.BURST_SYMBOLS, this.burstSymbols, this);
    dispatcher.on(eventDispatchers.BURST_SYMBOLS_DESTROY, this.resetBurstSymbols, this);
  }

  /**
   * This method start the burst animation of the symbols
   * @cascadeOffsets win offsets of burst symbols
   */
  private burstSymbols(): void {
    const cascadeOffsets: number[][][] = (ingenuity.parserModel as GameParserModel).getCascadeOffsets();
    this.playAllBurstAnimByOffsets(cascadeOffsets[0]);
  }

  /**
   * This method returns all burst animation spine
   * @param offsets win offsets
   */
  private playAllBurstAnimByOffsets(offsets: number[][]): void {
    this.cascadingReelsParentContainer.x = gameConstants.BG_CASCADING_CONTAINERX;
    dispatcher.fireEvent(SlotEventConstants.HIDE_ALL_PAYLINE_WINBOX);
    dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_ALL_SYMBOL_ANIM);
    let newSpine: SpineBase;
    this.convertStackInIndividualSymbol(offsets);
    offsets.forEach((pos: number[]) => {
      const reelId: number = pos[0];
      const symId: number = pos[1];
      let reel: Reel = this.view.getReelView().getReels()[reelId];
      let sym: SymbolBase = this.view.getReelView().getSymbolByPos(reelId, symId);
      this.cascadeSymArray.push(sym);
      newSpine = this.getSpineJsonAndClone();
      newSpine.x = reel.x;
      newSpine.y = sym.y;
      let newContainer: Container = this.cascadeView.getContainerByID(gameConstants.CASCADE_REEL_CONTAINER_ID + String(reelId));
      newContainer.addChild(newSpine);
      newSpine.playAnim(gameConstants.ANIMATION_STRING_ID);
      delayedCall(
        gameConstants.HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY + reelId + symId,
        gameConstants.TIMER_200,
        () => { 
          killDelayedCall(gameConstants.HIDE_SYMBOLS_ON_BURST_ANIMATION_PLAY + reelId + symId);
          sym.getStatic().visible = false;
        },
        this
      );
      this.burstSpineArray.push(newSpine);
    }, this);
    delayedCall(gameConstants.START_REEL_DROP_ON_BURST_ANIMATION_PLAY, gameConstants.TIMER_300, () => {
      killDelayedCall(gameConstants.START_REEL_DROP_ON_BURST_ANIMATION_PLAY);
      this.dissolveSymbolPositions();
    });
  }

  /**
   * This method destroys the burst animation spine on next spin call
   */
  private convertStackInIndividualSymbol(casCadePosition: number[][]): void {
    let reelGrid: number[][] = clone((ingenuity.parserModel as GameParserModel).getGameGridForStack());
    let stackData: number[][] = gameConstants.MAN_AND_LADY_STACK_DATA;
    let playSplitSound = false
    stackData.forEach((data: number[]) => {
      let stackId: number = data[2];
      casCadePosition.forEach((pos: number[]) => {
        if (reelGrid[pos[0]][pos[1]] === stackId) {
          reelGrid = this.updateValueInGrid(pos[0], pos[1], reelGrid, data);
          playSplitSound = true
        } else if (reelGrid[pos[0]][pos[1]] === gameConstants.TRANSPARENT_SYMBOL_ID) {
          for (let i = pos[1] - 1; i >= 0; i--) {
            if (reelGrid[pos[0]][i] === stackId) {
              reelGrid = this.updateValueInGrid(pos[0], i, reelGrid, data);
              break;
            }
          }
        }
      }, this);
    }, this);
    if(stackData.length &&playSplitSound){
       (ingenuity.soundManager as any).playSound(SoundConstantGame.CHAR_ICON_SEPERATE, 1, false, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
    }
    this.view.getReelView().showStaticGrid(reelGrid);
  }

  /**
   * Add to convert stack in individual symbol in grid
   */
  private updateValueInGrid(col: number, row: number, reelGrid: number[][], stackData: number[]): number[][] {
    let stackId: number = stackData[2];
    let stackSize: number = stackData[1];
    let stackReplaceId;
    if (stackId === gameConstants.MAN_SYMBOL_1X3_STACK_ID) {
      stackReplaceId = gameConstants.MAN_SYMBOL_ID;
    } else if (stackId === gameConstants.LADY_SYMBOL_1X3_STACK_ID) {
      stackReplaceId = gameConstants.LADY_SYMBOL_ID;
    }
    for (let i = 0; i < stackSize; i++) {
      reelGrid[col][row + i] && (reelGrid[col][row + i] = stackReplaceId);
    }
    return reelGrid;
  }

  /**
   * This method is use to burst symbol
   */
  private dissolveSymbolPositions(): void {
    for (let reelId = 0; reelId < ingenuity.configData.numberOfReel; reelId++) {
      this.view.getReelView().children[reelId].dissolveSymbolPositions(reelId);
    }
  }

/**
   * This method creates new spine via cloning
   * @returns return the spine
   */
  private getSpineJsonAndClone(): SpineBase {
    let cascadeEffect: ISpineData = this.cascadeView.json[gameConstants.CASCADE_SPINE_STRING_ID];
    let cascadeEffectAnim: SpineBase = this.view.createSpine(cascadeEffect);
    cascadeEffectAnim.visible = true;
    return cascadeEffectAnim;
  }

  /**
   * This method destroys the burst animation spine on next spin call
   */
  private resetBurstSymbols(): void {
    this.cascadeSymArray = [];
    this.burstSpineArray.forEach((spine: SpineBase) => {
      spine.destroy();
    }, this);
    this.burstSpineArray = [];
    const allComponents: any = this.view.getAllcomponents();
    delete allComponents["cascade_effect"];
  }
}
